<template>
  <div class="medkon-page">
    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-folder" /> Grup Topik
      <i class="bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'groupHelper' }" />
      <button v-if="isAdmin" id="tambah-group" class="btn btn-warning btn-icon-left pull-right" @click="addGroup">
        <i class="bi bi-plus"></i> Tambah Grup
      </button>
    </h6>
    <div ref="groupHelper" class="tooltip-content">
      <p>
        <b>Grup</b> digunakan untuk mengelompokkan beberapa topik menjadi satu.
        Hanya topik media online yang dapat dikelompokkan.
      </p>
      <p>
        <b>Topik</b> digunakan untuk mengelompokkan beberapa keyword menjadi
        satu.
      </p>
    </div>

    <div class="table-responsive m-b-30">
      <table class="table table-hover table-condensed table-detailed" id="table-grup">
        <thead>
          <tr>
            <th>Grup</th>
            <th class="text-center">Jumlah Topik</th>
            <th class="text-center">Jumlah Kata Kunci</th>
            <th v-if="isAdmin" class="text-center">Aksi</th>
          </tr>
        </thead>

        <tbody></tbody>
      </table>
    </div>

    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-key" /> Kata Kunci
      <span class="mx-1"></span>
      <i class="bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'keywordHelper' }" />
      <span class="mx-1"></span>
      <i class="bi bi-exclamation-circle text-yellow" v-tooltip.right="{ ref: 'keyHelper' }"></i>
      <button v-if="isAdmin" id="tambah-keyword" class="btn btn-warning btn-icon-left pull-right" @click="addKeyword">
        <i class="bi bi-plus"></i> Tambah Kata Kunci
      </button>
      <button id="export-keyword" class="btn btn-complete btn-icon-left pull-right mr-2" @click="exportKeyword">
        <i class="bi bi-filetype-xlsx"></i> Ekspor Kata Kunci
      </button>
    </h6>
    <div ref="keywordHelper" class="tooltip-content">
      <p>
        <b>Kata Kunci</b> merupakan kata kunci yang digunakan dalam pencarian data.
        Sistem akan memonitor postingan media online yang mengandung kata
        kunci tersebut.
      </p>
      <p>
        Crawler Media Online akan menggunakan Kata Kunci ini.
      </p>
    </div>
    <div ref="keyHelper" class="tooltip-content">
      <p>Penulisan Kata Kunci (frasa):</p>
      <small>
        Gunakan tanda kutip ("") untuk frasa atau kata kunci secara lengkap
      </small>
      <br><br>
      <small>Contoh:</small>
      <ul>
        <li><small>"TNI AU"</small></li>
      </ul>
      <small>akan crawler data berdasarkan kata kunci secara lengkap misal '<strong class="text-warning">TNI AU</strong>
        sedang mengadakan
        ....'</small>
      <hr class="my-2">
      <p>Penulisan Kata Kunci (non-frasa):</p>
      <small>
        Tulis kata kata kunci tanpa tanda kutip ("") untuk mencari berdasarkan kata kunci yang ada
      </small>
      <br><br>
      <small>Contoh:</small>
      <ul>
        <li><small>TNI AU</small></li>
      </ul>
      <small>akan crawler data berdasarkan kata kunci yang tertera misal '<strong class="text-warning">TNI</strong>
        sedang mengadakan .... yang berada di...... '</small>
    </div>

    <div class="table-wrapper">
      <table class="table table-hover table-condensed" id="daftar-keyword" style="width: 100%">
        <thead>
          <tr>
            <th>Grup</th>
            <th>Topik</th>
            <th width="40%">Kata Kunci</th>
            <th>dikecualikan</th>
            <th v-if="isAdmin" class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="is_loading_keyword">
            <td colspan="5" align="center">Loading...</td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal-dynamic-component v-if="modal" :key="modal_key" :modal="modal" :data="modal.data" :static="true" />
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
    <floating-loader-component v-if="is_loading_float" />
  </div>
</template>

<script>
import swal from "sweetalert";
import modal_add_keyword from "@/views/components/settings/keyword/modal_add_keyword.vue";
import modal_add_topic from "@/views/components/settings/keyword/modal_add_topic.vue";
import modal_edit_keyword from "@/views/components/settings/keyword/modal_edit_keyword.vue";
import modal_edit_topic from "@/views/components/settings/keyword/modal_edit_topic.vue";
import modal_add_group from "@/views/components/settings/keyword/modal_add_group.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import floating_loader from "@/views/components/floating_loader.vue";
import modal_query_topic from "@/views/components/settings/keyword/modal_query_topic.vue";
import XLSX from "xlsx";
import $ from "jquery";

export default {
  name: "tab_media_konvensional",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    "modal-dynamic-component": modal_dynamic,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      tour_steps: [],
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : atob(this.$route.query.ref),
      api: process.env.VUE_APP_API_URL,
      group: null,
      group_lists: null,
      keywords: null,
      datalist: [],
      table: null,
      count: [],
      chunkList: [],
      modal: null,
      modal_key: 0,
      is_loading: true,
      is_loading_keyword: true,
      is_loading_float: false,
      table_conf: {
        language: {
          thousands: ".",
          search: "Cari:",
          zeroRecords: "Data tidak tersedia",
          info: "Menampilkan halaman _PAGE_ dari _PAGES_",
          infoEmpty: "Menampilkan 0 data",
          lengthMenu: "Tampilkan _MENU_ data",
          "paginate": {
            "next": "Lanjut",
            "previous": "Sebelum"
          }
        },
        pageLength: 5,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        aaSorting: [[1, "desc"]],
      },
    };
  },
  methods: {
    assembleData: function (dataset) {
      let arr = [];
      let count = [];
      for (let i in dataset) {
        if (dataset[i].group in arr) {
          if (dataset[i].topic_id in arr[dataset[i].group]) {
            arr[dataset[i].group][dataset[i].topic_id].keyword.push({
              keyword: dataset[i].keyword,
            });
            count[dataset[i].group].keyword++;
          } else {
            arr[dataset[i].group][dataset[i].topic_id] = {
              name: dataset[i].topic,
              keyword: [],
            };
            arr[dataset[i].group][dataset[i].topic_id].keyword.push({
              keyword: dataset[i].keyword,
            });
            count[dataset[i].group].topic++;
            count[dataset[i].group].keyword++;
          }
        } else {
          count[dataset[i].group] = {
            topic: 0,
            keyword: 0,
          };
          count[dataset[i].group].topic++;
          count[dataset[i].group].keyword++;
          arr[dataset[i].group] = [];
          arr[dataset[i].group][dataset[i].topic_id] = {
            name: dataset[i].topic,
            keyword: [],
          };
          arr[dataset[i].group][dataset[i].topic_id].keyword.push({
            keyword: dataset[i].keyword,
          });
        }
      }
      this.datalist = arr;
      this.count = count;
    },
    getGroup: function () {
      self.$(self.$(".shown")).removeClass("shown");
      self.$(".row-details").remove();
      let api = this.api + "list-topics/" + this.id_project;
      this.group = {
        formed: [],
      };
      this.is_loading = true;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.group = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getDataGroupList();
          this.is_loading = false;
        });
    },
    getDataGroupList: function () {
      let api = this.api + "display-groups/" + this.id_project;
      this.group_lists = {};
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.group_lists = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.assembleDataTable(this.group_lists);
        });
    },
    assembleDataTable: function (dataGroupList) {
      let btn;
      this.tableTopik.clear().draw();

      for (let id in dataGroupList) {
        let jumlahTopik = `<center>${id in this.group.formed
          ? Object.entries(this.group.formed[id].topics).length
          : 0
          }</center>`;

        let keyword = `<center>${this.count[dataGroupList[id]]
          ? this.count[dataGroupList[id]].keyword
          : 0
          }</center>`;
        btn =
          '<center><button id="tambah-topik" class="btn btn-sm btn-warning m-r-5 btn-grup-add"><i class="bi bi-plus"></i></button><button id="edit-group" class="btn btn-sm btn-complete m-r-5 btn-group-change"><i class="bi bi-pencil-square"></i></button><button id="hapus-group" class="btn btn-sm btn-danger btn-group-delete"><i class="bi bi-trash"></i></button></center>';

        if (this.isAdmin) {
          this.tableTopik.row
            .add([dataGroupList[id], jumlahTopik, keyword, btn])
            .node().id = id;
        } else {
          this.tableTopik.row
            .add([dataGroupList[id], jumlahTopik, keyword])
            .node().id = id;
        }

        this.tableTopik.draw(false);
      }
    },
    getKeyword: function () {
      let api = this.api + "formed-keywords/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.keywords = response.data;
          this.assembleData(this.keywords);
          this.generateTable("#daftar-keyword", this.keywords);
        } else {
          this.generateTable("#daftar-keyword", []);
        }
      });
    },
    showDetailGrup: function (index) {
      let btn = this.$(event.target).hasClass("btn");
      let icon = this.$(event.target).hasClass("pg-icon");
      if (!btn && !icon) {
        let self = this;
        let el = self.$(event.target).closest("tr");
        if (el.hasClass("shown")) {
          self.$(".row-details").remove();
          el.removeClass("shown");
        } else {
          self.$(self.$(".shown")).removeClass("shown");
          el.addClass("shown");
          self.$(self.$(el)).after(function () {
            self.$(".row-details").remove();
            let detail_el = "<tr class='row-details'>";
            detail_el += '<td colspan="4" class="p-t-10 p-b-10">';
            detail_el +=
              '<table class="table bg-complete" id="table-detail-grup">';
            detail_el += "<thead>";
            detail_el += "<tr>";
            detail_el += "<th class='text-center' style='width:5px'>No</th>";
            detail_el += "<th>Topik</th>";
            detail_el += "<th class='text-center'>Jumlah Keyword</th>";
            if (self.isAdmin) {
              detail_el += "<th class='text-center'>Aksi</th>";
            }
            detail_el += "</tr>";
            detail_el += "</thead>";
            detail_el += "<tbody>";
            detail_el += "</tbody>";
            if (index in self.group.formed) {
              let no = 1;
              let topik = self.group.formed[index].group_name;
              if (self.isAdmin) {
                for (let row in self.group.formed[index].topics) {
                  let jumlah_keyword;
                  if (
                    self.datalist[topik][row] != undefined ||
                    self.datalist[topik][row] != null
                  ) {
                    jumlah_keyword = self.datalist[topik][row].keyword.length;
                  } else {
                    jumlah_keyword = 0;
                  }

                  let btn =
                    '<button class="btn btn-sm btn-warning m-r-5 btn-topic-query" data-topic="' +
                    self.group.formed[index].topics[row] +
                    '" data-id="' +
                    row +
                    '" data-group-id="' +
                    index +
                    '"><i class="bi bi-database"></i></button> <button class="btn btn-sm btn-complete m-r-5 btn-topic-change" data-id="' +
                    row +
                    '" data-group-id="' +
                    index +
                    '"><i class="bi bi-pencil-square"></i></button><button class="btn btn-sm btn-danger btn-topic-delete" data-id="' +
                    row +
                    '"><i class="bi bi-trash"></i></button>';
                  detail_el +=
                    "<tr><td><center>" +
                    no +
                    "</center></td><td>" +
                    self.group.formed[index].topics[row] +
                    "</td><td><center>" +
                    jumlah_keyword +
                    "</center></td><td class='text-center'>" +
                    btn +
                    "</td></tr>";
                  no++;
                }
              } else {
                for (let row in self.group.formed[index].topics) {
                  detail_el +=
                    "<tr><td><center>" +
                    no +
                    "</center></td><td><center>" +
                    self.group.formed[index].topics[row] +
                    "</center></td><td><center>" +
                    self.datalist[topik][row].keyword.length +
                    "<center></td></tr>";
                  no++;
                }
              }
            } else {
              detail_el +=
                '<tr><td colspan="4" align="center">Mohon maaf, data tidak tersedia!</td></tr>';
            }

            detail_el += "</table>";

            detail_el += "</td>";
            detail_el += "</tr>";
            return detail_el;
          });
        }
      }
    },
    deleteGroup: function (id) {
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus grup tersebut. Menghapus grup akan membuat topik dan keyword yang ada didalamnya ikut terhapus.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          this.$store.dispatch("loading", true);
          this.is_loading_float = true;
          let data = {
            _id: id,
          };
          let api = this.api + "new-group-delete";
          this.$http
            .post(api, data)
            .then((response) => {
              if (response.status == 200) {
                this.$store.dispatch("loading", false);
                this.getGroup();
                this.getKeyword();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Grup berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                this.$store.dispatch("loading", false);
                this.getGroup();
                this.getKeyword();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Gagal!</b> Grup gagal dihapus, data not sync',
                    position: "top",
                    timeout: 5000,
                    type: "error",
                  })
                  .show();
              }
            })
            .catch(function () {
              this.$store.dispatch("loading", false);
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus grup. data tidak sync atau lainya',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.is_loading_float = false;
            });
        }
      });
    },
    deletekeyword: function (topic_id, keyword) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus keyword tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          self.$store.dispatch("loading", true);
          let params = {
            _id: topic_id,
            keyword: keyword,
            tipe: 2,
          };
          let api = process.env.VUE_APP_API_URL + "new-keyword-delete";
          this.is_loading_float = true;
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.$store.dispatch("loading", false);
                self.getKeyword();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Keyword berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function () {
              self.$store.dispatch("loading", false);
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus keyword. data tidak sync atau lainya',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.is_loading_float = false;
              this.initData()
            });
        }
      });
    },
    generateTable: function (id, data) {
      if (this.isAdmin) {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            // emptyTable: "Mohon maaf, data tidak tersedia!",
            search: "Cari:",
            zeroRecords: "Data tidak tersedia",
            info: "Menampilkan halaman _PAGE_ dari _PAGES_",
            infoEmpty: "Menampilkan 0 data",
            lengthMenu: "Tampilkan _MENU_ data",
            "paginate": {
              "next": "Lanjut",
              "previous": "Sebelum"
            }
          },
          columns: [
            { data: "group" },
            { data: "topic" },
            { data: "keyword", class: "td-actions" },
            { data: "excludes" },
            { data: "topic_id", class: "td-actions" },
          ],
          columnDefs: [
            {
              targets: 4,
              orderable: false,
            },
            {
              render: function (data, type, row) {
                let btn =
                  '<center><button id="edit-keyword" class="btn btn-sm btn-complete ch m-r-5" data-id="' +
                  row.topic_id +
                  '"><i class="bi bi-pencil-square"></i></button><button id="hapus-keyword" class="btn btn-danger btn-sm del" data-id="' +
                  row.topic_id +
                  '"><i class="bi bi-trash"></i></button></center>';
                return btn;
              },
              targets: 4,
            },
          ],
        });
      } else {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            // emptyTable: "Mohon maaf, data tidak tersedia!",
            search: "Cari:",
            zeroRecords: "Data tidak tersedia",
            info: "Menampilkan halaman _PAGE_ dari _PAGES_",
            infoEmpty: "Menampilkan 0 data",
            lengthMenu: "Tampilkan _MENU_ data",
            "paginate": {
              "next": "Lanjut",
              "previous": "Sebelum"
            }
          },
          columns: [
            { data: "group" },
            { data: "topic" },
            { data: "keyword", class: "td-actions" },
            { data: "excludes" },
          ],
        });
      }
    },
    addKeyword: function () {
      let data = [{ tipe: 2, callback: this.initData }];
      if (this.$store.getters.user.id_project == 0) {
        data[0].tipe_project = this.data["tipe_project"];
      }
      if (!this.modal) {
        this.modal = {
          title: "Tambah Kata Kunci",
          subtitle:
            "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan",
          component: modal_add_keyword,
          data: data,
        };
      } else {
        this.modal = {
          title: "Tambah Kata Kunci",
          subtitle:
            "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan",
          component: modal_add_keyword,
          data: data,
        };
        this.modal_key++;
      }
    },
    editKeyword: function (data) {
      if (!this.modal) {
        let arr_data = [];
        arr_data["topic_id"] = data.topic_id;
        arr_data["keyword"] = data.keyword;
        arr_data["excludes"] = data.excludes;
        arr_data["tipe"] = 2;
        arr_data["callback"] = this.initData;
        this.modal = {
          title: "Edit Kata Kunci",
          subtitle:
            "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan",
          component: modal_edit_keyword,
          data: arr_data,
        };
      } else {
        let arr_data = [];
        arr_data["topic_id"] = data.topic_id;
        arr_data["keyword"] = data.keyword;
        arr_data["excludes"] = data.excludes;
        arr_data["tipe"] = 2;
        arr_data["callback"] = this.initData;
        this.modal = {
          title: "Edit Kata Kunci",
          subtitle:
            "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan",
          component: modal_edit_keyword,
          data: arr_data,
        };
        this.modal_key++;
      }
    },
    addGroup: function () {
      if (!this.modal) {
        this.modal = {
          title: "Tambah Grup",
          subtitle: "Silahkan masukan nama grup yang akan ditambahkan",
          component: modal_add_group,
          data: [{ callback: this.getGroup }],
        };
      } else {
        this.modal = {
          title: "Tambah Grup",
          subtitle: "Silahkan masukan nama grup yang akan ditambahkan",
          component: modal_add_group,
          data: [{ callback: this.getGroup }],
        };
        this.modal_key++;
      }
    },
    editGroup: function (id, group) {
      if (!this.modal) {
        this.modal = {
          title: "Edit Grup",
          subtitle: "Silahkan masukan nama grup baru",
          component: modal_add_group,
          data: [
            {
              callback: this.getGroup,
              group: group,
              id: id,
            },
          ],
        };
      } else {
        this.modal = {
          title: "Edit Grup",
          subtitle: "Silahkan masukan nama grup baru",
          component: modal_add_group,
          data: [
            {
              callback: this.getGroup,
              group: group,
              id: id,
            },
          ],
        };
        this.modal_key++;
      }
    },
    deleteTopic: function (id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus Topik tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          self.$store.dispatch("loading", true);
          this.is_loading_float = true;
          let params = {
            _id: id,
            tipe: 2,
          };
          let api = self.api + "new-topic-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.$store.dispatch("loading", false);
                self.initData();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Topik berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                self.$store.dispatch("loading", false);
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus topik. data tidak sync atau lainya',
                    position: "top",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch(function () {
              self.$store.dispatch("loading", false);
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus topik. data tidak sync atau lainya',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.is_loading_float = false;
            });
        }
      });
    },
    addTopic: function (group_id) {
      let data = [
        {
          tipe: 2,
          group: this.group_lists,
          callback: this.initData,
          selected_group: group_id,
        },
      ];
      if (this.$store.getters.user.id_project == 0) {
        data[0].tipe_project = this.data["tipe_project"];
      }
      if (!this.modal) {
        this.modal = {
          title: "Tambah Topik",
          subtitle: "Silahkan masukan topik yang akan dimonitor",
          component: modal_add_topic,
          data: data,
        };
      } else {
        this.modal = {
          title: "Tambah Topik",
          subtitle: "Silahkan masukan topik yang akan dimonitor",
          component: modal_add_topic,
          data: data,
        };
        this.modal_key++;
      }
    },
    editTopic: function (index, group) {
      let data = [];
      data["topic"] = this.group.formed[group].topics[index];
      data["id_topic"] = index;
      data["tipe"] = 2;
      data["selected_group"] = group;
      data["group"] = this.list_group;
      data["callback"] = this.initData;
      if (this.$store.getters.user.id_project == 0) {
        data["tipe_project"] = this.data["tipe_project"];
      }
      if (!this.modal) {
        this.modal = {
          title: "Edit Topik",
          subtitle: "Silahkan masukan topik yang akan dimonitor",
          component: modal_edit_topic,
          data: data,
        };
      } else {
        this.modal = {
          title: "Edit Topik",
          subtitle: "Silahkan masukan topik yang akan dimonitor",
          component: modal_edit_topic,
          data: data,
        };
        this.modal_key++;
      }
    },
    exportKeyword: function () {
      if (this.keywords) {
        this.$store.dispatch("loading", true);
        let obj_rename = { topic_id: "topik_id", topic: "topik", keyword: "kata_kunci", 'excludes': 'dikecualikan', "group": "kelompok" }
        let remap_keyword = this.keywords.map(obj => {
          let data = Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
              obj_rename[key] || key, // Use the new key if it exists in the keyMap, otherwise use the original key
              value
            ])
          );
          delete data['botChecker']
          return data
        })
        var keyword_list = XLSX.utils.json_to_sheet(remap_keyword);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, keyword_list, "keywords");
        XLSX.writeFile(wb, "keyword_list.xlsx");
        this.$store.dispatch("loading", false);
      } else {
        this.$("body")
          .pgNotification({
            style: "bar",
            message: '<i class="bi bi-x-circle"></i> Data Keyword Kosong!.',
            position: "top",
            timeout: 5000,
            type: "danger",
          })
          .show();
      }
    },
    initData: function () {
      this.getKeyword();
      this.getGroup();
    },
    showQuery: function (data) {
      const temp = {
        id: data[0],
        tipe: "medkon",
      };
      if (!this.modal) {
        this.modal = {
          title: `Query Topik "${data[1]}"`,
          subtitle:
            "Berikut merupakan query dari keyword pada topik yang dipilih",
          component: modal_query_topic,
          data: temp,
        };
      } else {
        this.modal = {
          title: `Query Topik "${data[1]}"`,
          subtitle:
            "Berikut merupakan query dari keyword pada topik yang dipilih",
          component: modal_query_topic,
          data: temp,
        };
        this.modal_key++;
      }
    },
  },
  computed: {
    list_group: function () {
      let group = {};
      for (let row in this.group.formed) {
        let count_topic = Object.entries(this.group.formed[row].topics).length;
        if (row != 0 || count_topic > 0) {
          group[row] = this.group.formed[row];
        }
      }
      return group;
    },
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 1 || user_role == 2) {
        return true;
      }

      return false;
    },
  },
  mounted: function () {
    this.initData();
    this.tableTopik = $("#table-grup").DataTable(this.table_conf);
    let self = this;

    self.$("#daftar-keyword tbody").on("click", ".del", function () {
      var tr = self.$(this).closest("tr");
      var data = self.table.row(tr).data();
      self.deletekeyword(data.topic_id, data.keyword);
    });
    self.$("#daftar-keyword tbody").on("click", ".ch", function () {
      var tr = self.$(this).closest("tr");
      var data = self.table.row(tr).data();
      data["tipe"] = self.$(this).attr("data-tipe");
      self.editKeyword(data);
    });

    self.$("#table-grup").on("click", ".btn-group-delete", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.deleteGroup(id);
    });
    self.$("#table-grup").on("click", ".btn-group-change", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      let group = self.group_lists[id];

      self.editGroup(id, group);
    });
    self.$("#table-grup").on("click", ".btn-grup-add", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.addTopic(id);
    });
    self.$("#table-grup").on("click", "tbody tr", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.showDetailGrup(id);
    });
    self.$("#table-grup").on("click", ".btn-topic-query", function () {
      let id = self.$(this).attr("data-id");
      let topic = self.$(this).attr("data-topic");
      let data = [id, topic];
      self.showQuery(data);
    });
    self.$("#table-grup").on("click", ".btn-topic-change", function () {
      let id = self.$(this).attr("data-id");
      let group = self.$(this).attr("data-group-id");
      self.editTopic(id, group);
    });
    self.$("#table-grup").on("click", ".btn-topic-delete", function () {
      let id = self.$(this).attr("data-id");
      self.deleteTopic(id);
    });
    let v_step = [];
    v_step[0] = {
      target: "#tab-vertical",
      header: {
        title: "Tab Menu",
      },
      content: `Anda dapat memilih salah satu untuk melihat detail dari menu.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#tambah-group",
      header: {
        title: "Tombol Tambah Group Topik",
      },
      content: `Klik untuk menambahkan data group topik baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#table-grup_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari item yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#table-grup",
      header: {
        title: "Tabel Group Topik",
      },
      content: `Menampilkan daftar group topik. Klik salahsatu baris untuk melihat topik dari group yang dipilih`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#tambah-topik",
      header: {
        title: "Tombol Tambah Topik",
      },
      content: `Klik untuk menambahkan data topik baru pada group yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#edit-group",
      header: {
        title: "Tombol Edit Group",
      },
      content: `Klik untuk mengedit group yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#hapus-group",
      header: {
        title: "Tombol Hapus Group",
      },
      content: `Klik untuk menghapus group yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#tambah-keyword",
      header: {
        title: "Tombol Tambah Keyword",
      },
      content: `Klik untuk menambah data keyword baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#export-keyword",
      header: {
        title: "Tombol Export Keyword",
      },
      content: `Klik untuk mengekspor data keyword tersedia ke dalam file excel.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#daftar-keyword_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari keyword yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#daftar-keyword",
      header: {
        title: "Daftar Keyword",
      },
      content: `Menampilkan daftar keyword tersedia.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[11] = {
      target: "#edit-keyword",
      header: {
        title: "Tombol Edit Keyword",
      },
      content: `Klik untuk mengedit keyword yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[12] = {
      target: "#hapus-keyword",
      header: {
        title: "Tombol Hapus Keyword",
      },
      content: `Klik untuk menghapus keyword yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style>
.data-kosong::before {
  content: none !important;
}

.td-actions {
  text-overflow: clip !important;
}
</style>
